(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function findVariant(card, key, index) {
      var byKey = card.querySelector('[data-bf-variant][data-key="' + key + '"]');
      return byKey || card.querySelector('[data-bf-variant][data-index="' + index + '"]');
    }

    function setText(el, text) {
      if (!el) return;
      el.textContent = text || '';
      el.hidden = !text;
    }

    function applyVariant(card, v) {
      var d = v.dataset;
      card.style.setProperty('--bf-tint', d.tint);

      var img = card.querySelector('[data-bf-img]');
      if (img && d.img && img.getAttribute('src') !== d.img) {
        if (reduceMotion) {
          img.src = d.img;
        } else {
          img.style.opacity = '0';
          var next = new Image();
          next.onload = next.onerror = function () {
            img.src = d.img;
            img.style.opacity = '1';
          };
          next.src = d.img;
        }
      }
      if (img && d.alt) img.alt = d.alt;

      setText(card.querySelector('[data-bf-price]'), d.price);
      setText(card.querySelector('[data-bf-was]'), d.was);
      setText(card.querySelector('[data-bf-save]'), d.save ? 'Save ' + d.save : '');

      var rev = card.querySelector('[data-bf-rev]');
      if (rev) {
        rev.hidden = !d.rating;
        var rating = rev.querySelector('[data-bf-rating]');
        if (rating) rating.textContent = d.rating || '';
        setText(rev.querySelector('[data-bf-reviews]'), d.reviews ? '(' + d.reviews + ' reviews)' : '');
      }

      if (d.url) {
        card.querySelectorAll('[data-bf-link]').forEach(function (a) { a.setAttribute('href', d.url); });
      }
    }

    function preload(section) {
      if (section.dataset.bfPreloaded) return;
      section.dataset.bfPreloaded = '1';
      section.querySelectorAll('[data-bf-variant]').forEach(function (v) {
        if (v.dataset.img) new Image().src = v.dataset.img;
      });
    }

    function initSection(section) {
      if (!section || section.dataset.bfInit) return;
      section.dataset.bfInit = '1';
      var opts = section.querySelectorAll('[data-bf-opt]');
      if (!opts.length) return;
      var cards = section.querySelectorAll('[data-bf-card]');
      var switcher = opts[0].parentNode;

      switcher.addEventListener('pointerenter', function () { preload(section); }, { once: true });
      switcher.addEventListener('focusin', function () { preload(section); }, { once: true });

      opts.forEach(function (opt) {
        opt.addEventListener('click', function () {
          if (opt.getAttribute('aria-pressed') === 'true') return;
          opts.forEach(function (o) { o.setAttribute('aria-pressed', o === opt ? 'true' : 'false'); });
          cards.forEach(function (card) {
            var v = findVariant(card, opt.dataset.key, opt.dataset.index);
            if (v) applyVariant(card, v);
          });
        });
      });
    }

    function initAll() {
      document.querySelectorAll('[data-bf-section]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('[data-bf-section]');
      if (s) initSection(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-routine-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-lp-atc]');
    if (!btn || btn.disabled) return;
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      const cartItems = document.querySelector('cart-items-component');
      const sectionId = cartItems ? cartItems.dataset.sectionId : '';
      const res = await fetch('/cart/add.js?sections=' + sectionId, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add failed');
      const data = await res.json();
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: data,
          sourceId: 'landing-routine-cards',
          data: { itemCount: data.item_count, sections: data.sections, source: 'landing-routine-cards' }
        }
      }));
      btn.textContent = 'Added ✓';
      setTimeout(function () {
        const drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      }, 100);
    } catch (err) {
      btn.textContent = 'Error — try again';
    }
    setTimeout(function () {
      btn.textContent = originalText;
      btn.disabled = false;
    }, 2000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
